"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StaggeredFadeLoader } from "../../../../global-account/react/index.js";
import { cn } from "../../../../shared/utils/index.js";
import { isLightColor } from "../../../../shared/utils/colors.js";
import { useInView } from "react-intersection-observer";
export const ShinyButton = t0 => {
  const $ = _c(15);
  const {
    text: t1,
    accentColor,
    animatedPulse: t2,
    className: t3,
    children,
    onClick,
    onClickCapture,
    disabled,
    textColor: t4,
    textClassName: t5,
    type: t6
  } = t0;
  const text = t1 === undefined ? "shiny-button" : t1;
  const animatedPulse = t2 === undefined ? true : t2;
  const className = t3 === undefined ? "" : t3;
  const textColor = t4 === undefined ? "" : t4;
  const textClassName = t5 === undefined ? "" : t5;
  const type = t6 === undefined ? "button" : t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      triggerOnce: false,
      threshold: 0.1
    };
    $[0] = t7;
  } else {
    t7 = $[0];
  }
  const {
    ref,
    inView
  } = useInView(t7);
  const computedTextColor = textColor || (accentColor?.startsWith("hsl") ? "text-[rgb(0,0,0,65%)] dark:text-[rgb(255,255,255,90%)]" : accentColor && isLightColor(accentColor) ? "text-black/90" : "text-white");
  const t8 = `shiny-button relative min-h-fit rounded-2xl border border-black/10 px-6 py-3 tracking-wide backdrop-blur-xl transition-all duration-300 ease-in-out dark:bg-[radial-gradient(ellipse_at_50%_0%,hsl(var(--b3-react-primary)/25%)_0%,transparent_70%)] ${className}`;
  const t9 = disabled ? "grayscale-20 cursor-not-allowed opacity-60" : "hover:border-black/30 hover:shadow-[0_0_20px_rgb(0,0,0,20%)]";
  const t10 = animatedPulse && inView && "animated-pulse";
  let t11;
  if ($[1] !== accentColor || $[2] !== children || $[3] !== computedTextColor || $[4] !== disabled || $[5] !== onClick || $[6] !== onClickCapture || $[7] !== ref || $[8] !== t10 || $[9] !== t8 || $[10] !== t9 || $[11] !== text || $[12] !== textClassName || $[13] !== type) {
    t11 = _jsxs("button", {
      ref,
      className: cn(t8, t9, t10),
      style: {
        backgroundColor: disabled ? "#94A3B8" : accentColor
      },
      onClick: !disabled ? onClick : undefined,
      onClickCapture,
      disabled,
      type,
      children: [_jsx("div", {
        className: "absolute inset-0 bottom-0 left-0 right-0 top-0 rounded-2xl border border-white/10"
      }), _jsx("span", {
        className: cn("font-sf-rounded relative block h-full w-full text-lg font-semibold tracking-wide", computedTextColor),
        children: _jsxs("div", {
          className: cn("flex items-center justify-center gap-2", textClassName),
          children: [children || text, text === "Loading" && _jsx(StaggeredFadeLoader, {
            size: 2
          })]
        })
      }), _jsx("span", {
        className: "shiny-overlay"
      })]
    });
    $[1] = accentColor;
    $[2] = children;
    $[3] = computedTextColor;
    $[4] = disabled;
    $[5] = onClick;
    $[6] = onClickCapture;
    $[7] = ref;
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
    $[11] = text;
    $[12] = textClassName;
    $[13] = type;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
};